import { RadioGroupInput } from '@framework/form/inputs/RadioGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';

export const commonOptionListDirectionValidator = yup
  .string()
  .oneOf(['horizontal', 'vertical'])
  .required()
  .default('vertical');
export const commonOptionListSeparatorValidator = yup
  .string()
  .oneOf(['label', 'text'])
  .required()
  .default('label');

export interface ICommonOptionListConfigComponentProps {}

export function CommonOptionListConfigComponent(
  props: ICommonOptionListConfigComponentProps,
) {
  return (
    <div>
      <FormItem name="layout.direction" label="Orientamento opzioni">
        <RadioGroupInput
          defaultValue={'vertical'}
          name="layout.direction"
          options={[
            { label: 'Verticale', value: 'vertical' },
            { label: 'Orizzontale', value: 'horizontal' },
          ]}
        />
      </FormItem>
      <FormItem name="layout.separator" label="Dimensioni testo dei separatori">
        <RadioGroupInput
          defaultValue={'label'}
          name="layout.separator"
          options={[
            { label: 'Come etichette', value: 'label' },
            { label: 'Come testo', value: 'text' },
          ]}
        />
      </FormItem>
    </div>
  );
}
